import { language } from "@chef/constants";

export const intl = (
  {
    no: {
      ADDONS: "Dagligvarer",
      MEALS: "Middager",
      ORDER: "Bestilling",
    },
    se: {
      ADDONS: "Livsmedel",
      MEALS: "Middagar",
      ORDER: "Beställning",
    },
    dk: {
      MEALS: "Retter",
      ADDONS: "Specialvarer",
      ORDER: "Bestilling",
    },
  } as const
)[language];
